import { useEffect, useRef, useState } from "react";
import { undoStack, redoStack, undoEvent, redoEvent } from "../../features/events/store/event-store";

function update(prevLen: React.RefObject<number>) {
  const canUndo = undoStack.length > 0;
  const canRedo = redoStack.length > 0;
  prevLen.current = undoStack.length;
  return { canUndo, canRedo };
}

export function UndoFloatingButton() {
  const [visible, setVisible] = useState(false);
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);
  const prevLen = useRef(undoStack.length);

  // Poll stack lengths
  useEffect(() => {
    const interval = setInterval(() => {
      const len = undoStack.length;
      const redoLen = redoStack.length;
      if (len > prevLen.current) setVisible(true);
      else if (len === 0 && redoLen === 0) setVisible(false);
      prevLen.current = len;
      setCanUndo(len > 0);
      setCanRedo(redoLen > 0);
    }, 300);
    return () => clearInterval(interval);
  }, []);

  if (!visible) return null;

  const refresh = () => {
    const s = update(prevLen);
    setCanUndo(s.canUndo);
    setCanRedo(s.canRedo);
    if (!s.canUndo && !s.canRedo) setVisible(false);
  };

  return (
    <div className="fixed bottom-24 md:bottom-8 right-4 z-40 flex items-center gap-1 rounded-xl bg-neutral-900 shadow-xl animate-slide-up overflow-hidden">
      <button
        type="button"
        disabled={!canUndo}
        onClick={() => { undoEvent(); refresh(); }}
        className="flex items-center gap-1.5 px-3 py-2 text-neutral-200 text-xs font-medium
          hover:bg-neutral-800 active:scale-95 transition-all disabled:opacity-30 disabled:pointer-events-none"
        title="Annuler (Ctrl+Z)"
      >
        <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
          <polyline points="1 4 1 10 7 10" />
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
        </svg>
      </button>
      <div className="w-px h-4 bg-neutral-700" />
      <button
        type="button"
        disabled={!canRedo}
        onClick={() => { redoEvent(); refresh(); }}
        className="flex items-center gap-1.5 px-3 py-2 text-neutral-200 text-xs font-medium
          hover:bg-neutral-800 active:scale-95 transition-all disabled:opacity-30 disabled:pointer-events-none"
        title="Rétablir (Ctrl+Shift+Z)"
      >
        <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
          <polyline points="23 4 23 10 17 10" />
          <path d="M20.49 15a9 9 0 1 1-2.13-9.36L23 10" />
        </svg>
      </button>
    </div>
  );
}
